import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "payment-condition-wrapper d-flex align-items-center" }



// Props
interface Props {
	classes: string[]
	height?: number
	width?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentConditionPill',
  props: {
    classes: { default: () => [" bg-primary-blue", "text-white"] },
    height: { default: 20 },
    width: { default: 55 }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["payment-condition-tag d-flex justify-content-evenly align-items-center", props.classes]),
        style: _normalizeStyle({ height: `${props.height}px`, width: `${props.width}px` })
      }, [
        _renderSlot(_ctx.$slots, "icon"),
        _renderSlot(_ctx.$slots, "content")
      ], 6)
    ])
  ]))
}
}

})